import { Navigate } from 'react-router-dom'

// FAR-82: this page showed hardcoded demo months. Working days now live on the
// working-days screen, which reads and writes the plant's real calendar.
export default function BusinessCalendar() {
  return <Navigate to="/working-days" replace />
}
